import React from 'react'

const Footer = () => {
    return (
        <>
            <nav id="social" className="link-section">
                <h2><a href="index.html"><img id="footer-logo" src="assets/designs/leonhsulogo.png" alt="Leon Hsu Logo"></img></a></h2>
                <div className="social-container">
                    <a href="mailto:someone@example.com"><div className="contact-links"><i className="fas fa-envelope-square"></i></div></a>
                    <a href="https://github.com/leonhsu95"><div className="contact-links"><i className="fab fa-github"></i></div></a>
                    <a href="https://www.linkedin.com/in/leonhsu95/"><div className="contact-links"><i className="fab fa-linkedin"></i></div></a>
                </div>
            </nav>
            <small>&copy;2021 Leon Hsu | All Rights Reserved</small>
        </>
    )
}

export default Footer;
